import { PRODUCT_TYPES } from '@config/app.constants';
import { TWELVE_WEEK_SHORTLIST } from './constants';
import { routes } from './routes';

const productLists = {
  shortlist: routes.candidateShortlist,
  longlist: routes.longlist,
};

type GoToProductListArgs = {
  briefingId: string;
  prodType: PRODUCT_TYPES;
};

export const goToProductList = ({
  briefingId,
  prodType,
}: GoToProductListArgs): string => {
  return productLists[prodType].replace(':briefingId', briefingId);
};

// policy: default product type is Shortlist
export const step1Route = (prodType: PRODUCT_TYPES, duration?: string) => {
  if (prodType === PRODUCT_TYPES.longlist)
    return routes.briefingLonglistFormStep1;

  if (duration && duration === TWELVE_WEEK_SHORTLIST) {
    return `${routes.briefingShortlistFormStep1}?duration=${duration}`;
  }

  return routes.briefingShortlistFormStep1;
};

export const step2Route = (prodType: PRODUCT_TYPES, duration?: string) => {
  if (prodType === PRODUCT_TYPES.longlist)
    return routes.briefingLonglistFormStep2;

  if (duration && duration === TWELVE_WEEK_SHORTLIST) {
    return `${routes.briefingShortlistFormStep2}?duration=${duration}`;
  }

  return routes.briefingShortlistFormStep2;
};
